export const CONFIG_WIDTH = 320;
export const DEFAULT_HEIGHT = 42;
export const DEFAULT_WIDTH = 400;
export const PADDING = 4;
